"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const test_1 = require("./node/expression/test");
const callable_wrapper_1 = require("./callable-wrapper");
const merge = require('merge');
class TwingTest extends callable_wrapper_1.TwingCallableWrapper {
    /**
     * Creates a template test.
     *
     * @param {string} name Name of this test
     * @param {Function} callable A callable implementing the test. If null, you need to overwrite the "node_class" option to customize compilation.
     * @param {TwingTestOptions} options Options
     */
    constructor(name, callable = null, options = {}) {
        super(name, callable);
        this.methodArguments = [];
        this.options = merge({
            is_variadic: false,
            node_factory: function (node, name, nodeArguments, lineno, columnno) {
                return new test_1.TwingNodeExpressionTest(node, name, nodeArguments, lineno, columnno);
            },
            deprecated: false,
            alternative: null,
        }, options);
    }
    getNodeFactory() {
        return this.options.node_factory;
    }
    setArguments(someArguments) {
        this.methodArguments = someArguments;
    }
    getArguments() {
        return this.methodArguments;
    }
    isVariadic() {
        return this.options.is_variadic;
    }
    isDeprecated() {
        return this.options.deprecated ? true : false;
    }
    getDeprecatedVersion() {
        return this.options.deprecated;
    }
    getAlternative() {
        return this.options.alternative;
    }
}
exports.TwingTest = TwingTest;
